"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Redirect = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const getComponent_1 = require("../../getComponent");
const NavigationActions = getComponent_1.getComponent('NavigationActions');
/**
 * 🔀 Redirect
 */
const Redirect = (props) => {
    const { routeName, path, params, push } = props;
    return (react_1.default.createElement(NavigationActions, null, ({ push: pushFn, replace }) => {
        const fn = push === true ? pushFn : replace;
        if (typeof routeName === 'string') {
            fn(routeName, params);
        }
        else if (typeof path === 'string') {
            fn({ path }, params);
        }
        return null;
    }));
};
exports.Redirect = Redirect;
exports.Redirect.defaultProps = {
    push: false,
};
